<template>
  <div class="itinerario-wrapper">
    <!-- Mariposa decorativa en el borde izquierdo -->
    <img
      src="@/assets/mariposas.png"
      alt="Mariposa decorativa"
      class="mariposa-izquierda"
      ref="mariposaRef"
    />

    <div class="rasgado rasgado-superior"></div>

    <section class="itinerario-section">
      <div class="timeline-container">
        <h2 class="timeline-title">
          Itinerario
          <span class="sub">
            Agradecemos tu puntualidad. <br />
            ¡No queremos empezar sin ti ni que te pierdas el vals! Llega a tiempo para compartir cada momento especial.
          </span>
        </h2>

        <div class="timeline">
          <div
            v-for="evento in eventos"
            :key="evento.nombre"
            :ref="el => eventoRefs.push(el)"
            class="timeline-item"
          >
            <div class="timeline-line" />
            <div class="timeline-icon-wrapper">
              <div class="timeline-star">★</div>
              <div class="timeline-icon-circle">
                <img :src="evento.icono" :alt="evento.nombre" class="timeline-icon" />
              </div>
            </div>

            <!-- NUEVO: contenido con NOMBRE + hora/nota -->
            <div class="timeline-content">
              <h3 class="timeline-name">{{ evento.nombre }}</h3>
              <div class="timeline-time">
                <p>{{ evento.hora }}</p>
                <p v-if="evento.nota" class="nota">{{ evento.nota }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="rasgado rasgado-inferior"></div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'ItinerarioComponent',
  setup() {
    const eventos = [
      { nombre: 'Recepción', hora: '4:30 PM', icono: require('@/assets/recepcion_time.png'), nota: 'El Quijote Salón de Actividades' },
      { nombre: 'Ceremonia', hora: '5:00 PM', icono: require('@/assets/vals.png') },
      { nombre: 'Cena', hora: '6:00 PM', icono: require('@/assets/cena_time.png') },
      { nombre: 'Fiesta', hora: '7:00 PM - 10:30 PM', icono: require('@/assets/fiesta_time.png') },
    ]

    const eventoRefs = ref([])
    const mariposaRef = ref(null)

    onMounted(() => {
      eventoRefs.value.forEach((el) => {
        if (!el) return
        const icon = el.querySelector('.timeline-icon')
        const star = el.querySelector('.timeline-star')
        const nameEl = el.querySelector('.timeline-name')
        const time = el.querySelector('.timeline-time')

        gsap.set([icon, star, nameEl, time], { opacity: 0, y: 50 })

        const observer = new IntersectionObserver(
          (entries, obs) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                gsap.to(icon, { opacity: 1, y: 0, delay: 0.1, duration: 1, ease: 'power2.out' })
                gsap.to(star, { opacity: 1, scale: 1, delay: 0.2, duration: 1, ease: 'back.out(1.7)' })
                gsap.to(nameEl, { opacity: 1, y: 0, delay: 0.3, duration: 0.9, ease: 'power2.out' })
                gsap.to(time, { opacity: 1, y: 0, delay: 0.45, duration: 0.9, ease: 'power2.out' })
                obs.unobserve(entry.target)
              }
            })
          },
          { threshold: 0.3 }
        )

        observer.observe(el)
      })

      // Animación mariposa (entrada + flotado)
      if (mariposaRef.value) {
        gsap.fromTo(
          mariposaRef.value,
          { opacity: 0, x: -40, y: -10, rotate: -8, scale: 0.92 },
          { opacity: 1, x: 0, y: 0, rotate: 0, scale: 1, duration: 1.1, ease: 'power3.out' }
        )
        gsap.to(mariposaRef.value, {
          y: '+=10',
          rotate: 2,
          duration: 2.2,
          ease: 'sine.inOut',
          yoyo: true,
          repeat: -1
        })
      }
    })

    return { eventos, eventoRefs, mariposaRef }
  }
}
</script>

<style scoped>
.itinerario-section {
  padding: 40px 20px;
  background-image:
    linear-gradient(to bottom, rgba(255,255,255,0.78), rgba(255,255,255,0.6)),
    url('../assets/gold.jpg');
  background-size: cover;
  background-position: center;
  margin-top: -20px;
  margin-bottom: -20px;
  overflow: visible;

  color: #202020;
}

.timeline-container {
  max-width: 360px;
  margin: 20px auto 0;
  position: relative;
}

.timeline-title {
  text-align: center;
  font-family: 'FeelingPassionate';
  font-size: 46px;
  margin-bottom: 32px;
  color: #434040;
}
.timeline-title .sub {
  display: block;
  font-size: 18px;
  font-family: serif;
  margin-top: 8px;
  color: #434040;
}

.timeline {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 40px;
  border-left: 3px solid rgb(202, 202, 216);
}

.timeline-item {
  position: relative;
  padding-left: 30px;
  margin-bottom: 38px;
  display: flex;
  align-items: center;
}

.timeline-line {
  position: absolute;
  top: 0;
  left: -1.5px;
  width: 3px;
  height: 100%;
  background-color: rgb(30, 30, 31);
  z-index: -1;
}

.timeline-icon-wrapper {
  display: flex;
  align-items: center;
}

.timeline-star {
  color: #0b0a0a;
  font-size: 22px;
  margin-right: 10px;
  transform-origin: center;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 30px;
  min-height: 30px;
}
.timeline-icon-circle {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: rgb(80,77,77);
  display: flex;
  align-items: center;
  justify-content: center;
}
.timeline-icon {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

/* NUEVO: bloque de contenido */
.timeline-content {
  margin-left: 15px;
}

.timeline-name {
  font-family: 'Josefin Sans', sans-serif;
  font-size: 20px;
  line-height: 1.2;
  color: #222;
  letter-spacing: .2px;
  text-shadow: 0 1px 0 rgba(255,255,255,0.6);
  margin: 0 0 6px 0;
  text-align: left;         /* 🔥 Texto alineado a la izquierda */
}

.timeline-time {
  font-family: 'Josefin Sans', sans-serif;
  font-size: 16px;
  color: #0f0e0e;
  text-align: left;
}
.timeline-time .nota {
  font-size: 14px;
  color: #010000;
  margin-top: 2px;
  font-style: italic;
}

/* Rasgados */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 50px;
  background-color: #d9d2f1 !important;
  z-index: 12;
  pointer-events: none;
}
.rasgado-superior {
  top: 0;
  clip-path: polygon(0% 80%, 25% 60%, 50% 85%, 75% 55%, 100% 75%, 100% 0%, 0% 0%);
}
.rasgado-inferior {
  bottom: 0;

  clip-path: polygon(0% 20%, 25% 40%, 50% 15%, 75% 45%, 100% 25%, 100% 100%, 0% 100%);
}
.itinerario-wrapper { position: relative; }

/* Mejora en pantallas anchas */
@media (min-width: 768px) {
  .timeline-container { max-width: 640px; }
  .timeline-name { font-size: 34px; }
  .timeline-time { font-size: 18px; }
}

/* Mariposa borde izquierdo */
.mariposa-izquierda {
  position: absolute;
  left: -22px;     /* pegada al borde */
  top: 30%;
  width: 80px;
  height: auto;
  opacity: 0;      /* aparece con GSAP */
  filter: drop-shadow(0 6px 10px rgba(0,0,0,0.15));
  pointer-events: none;
  transform-origin: 60% 40%;
}
</style>
